let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JapJm")).then(() => parcelRequire('4SLjS'));